"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Image_1 = require("../template/Image");
require("./styles/Button.scss");
function Button(_a) {
    var name = _a.name, active = _a.active, className = _a.className, size = _a.size, icon = _a.icon, children = _a.children, disabled = _a.disabled, submit = _a.submit, handleClick = _a.handleClick, handleMouseIn = _a.handleMouseIn, handleMouseLeave = _a.handleMouseLeave, progressIndication = _a.progressIndication, ariaAttributes = _a.ariaAttributes, htmlAttributes = _a.htmlAttributes;
    var disabledStr;
    if (disabled === true) {
        disabledStr = 'disabled';
    }
    var wrapperClass = ['button'];
    if (className) {
        wrapperClass.push(className);
    }
    if (size) {
        wrapperClass.push(size);
    }
    if (active) {
        wrapperClass.push('active');
    }
    if (progressIndication) {
        wrapperClass.push('progress-indication inverted');
    }
    var iconElement;
    if (icon) {
        iconElement = React.createElement("span", { className: 'icon' },
            React.createElement(Image_1.default, { src: icon }));
        wrapperClass.push('has-icon');
    }
    var type;
    if (!submit) {
        type = 'button';
    }
    return (React.createElement("button", __assign({ type: type, className: wrapperClass.join(' '), disabled: disabledStr, onClick: handleClick, onMouseEnter: handleMouseIn, onMouseLeave: handleMouseLeave, name: name }, ariaAttributes, htmlAttributes),
        iconElement,
        children));
}
exports.default = Button;
